import React, { useEffect, useState } from 'react'
import { FiAlertTriangle, FiArrowLeftCircle, FiSave, FiSlash, FiTrash2 } from 'react-icons/fi';
import { Table } from '../../components/tables/Table';
import Swal from 'sweetalert2';
import { M_Document } from './documents/M_Document';
import { useDispatch, useSelector } from 'react-redux';
import { changedState, editRequest, loadDetailRequest } from '../../app/store/requests/thunk';
import { InputValidators } from '../../utils/InputValidators';
import { Loading } from '../../components/Loading';

export const EditRequest = ({ navigateTo, data }) => {
    
    const dispatch = useDispatch();
    const { isLoading, detailRequest, detailItems, msg } = useSelector(state => state.requests);
      const { usuario, id_emp } = useSelector(state => state.usuario);

    useEffect(() => {
        dispatch(loadDetailRequest(data?.id || 0));
    }, []);

    const [showModal, setShowModal] = useState(false);
    const handleOpenModal = (type) => {
        // setSearchType(type);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setShowModal(false);
        // setSearchType(null);
    };

    let user = id_emp;

    const [isEditing, setIsEditing] = useState(false);

    const purcharseOrder = detailRequest;
    const [ProductsToADD, setProductsToADD] = useState([]);

    useEffect(() => {
        setProductsToADD(detailItems || []);
    }, [detailItems]);

    const purchaseOrderDetails = ProductsToADD;


    const handleChangeApprovedQty = (sku, value) => {
        setProductsToADD(prev =>
            prev.map(p =>
                p.SKU === sku ? { ...p, QUANTITY_APPROVED: value } : p
            )
        );
    };


    let listProductsAddColumns = [
        {
            header: 'SKU',
            dataIndex: 'SKU',
            classHeader: 'text-start',
            classRow: 'text-start',

        },
        {
            header: 'CATEGORIA',
            dataIndex: 'NAMECATEGORY',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'MARCA',
            dataIndex: 'NAMEBRAND',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'PRODUCTO',
            dataIndex: 'NAME_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'DESCRIPCION',
            dataIndex: 'DESCRIPTION_PRODUCT',
            classHeader: 'text-start',
            classRow: 'text-start',
        },

        {
            header: 'PROVEEDOR',
            dataIndex: 'NAMESUPPLIER',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'CANT. REQUERIDA',
            dataIndex: 'QUANTITY',
            classHeader: 'text-center',
            classRow: 'text-center',
        },
        {
            header: 'CANT. APROBADA',
            dataIndex: 'QUANTITY_APPROVED',
            classHeader: 'text-center',
            classRow: 'text-center',
            renderer: (value, row) => (
                <input
                    type="number"
                    className="form-control text-center"
                    min={0}
                    onKeyDown={InputValidators.validateOnlyNumbers}
                    style={{ width: "80px", margin: "0 auto" }}
                    value={Number(value ?? '')}
                    disabled={!isEditing}
                    onChange={(e) => handleChangeApprovedQty(row.SKU, Number(e.target.value))}
                />
            )
        },

    ];

    const saveData = () => {
        let allApprovedZero = ProductsToADD.every(
            item => Number(item.QUANTITY_APPROVED) === 0
        );

        if (allApprovedZero) {
            Swal.fire({
                icon: "question",
                title: "Atencion",
                text: "No se ha aprovado ningun producto para la compra, la orden se marcara como rechazada, ¿Desea de continuar con esta acción?`",
                customClass: {
                    confirmButton: 'btn btn-primary  me-2',
                    cancelButton: 'btn btn-secondary'
                },
                showCancelButton: true, // <-- ¡Este es importante!
                confirmButtonText: 'Sí, continuar',
                cancelButtonText: 'No, cancelar',
                buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
            }).then((result) => {
                if (result.isConfirmed) {
                    // console.log(ProductsToADD);
                    setIsEditing(false);
                    dispatch(editRequest(ProductsToADD, user, purcharseOrder?.NUMBER, 7));
                    navigateTo('list');
                }
            })
            return;
        }


        Swal.fire({
            title: 'Atención',
            text: `Está por actualizar la informacion de la Orden de Compra, esta se marcara como aprobada con las cantidades indicadas a cada producto, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true, // <-- ¡Este es importante!
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false // Esto permite que tus clases personalizadas funcionen bien
        }).then((result) => {
            if (result.isConfirmed) {
                setIsEditing(false);
                dispatch(editRequest(ProductsToADD, user, purcharseOrder?.NUMBER, 3));
                navigateTo('list');
            }
        })
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }

    const chanegeStateOrder = (e) => {

        let status = e.target.value;
        Swal.fire({
            title: 'Atención',
            text: `Está por cambiar el estado de la Orden de compra ${purcharseOrder?.NUMBER}, ¿Desea de continuar con esta acción?`,
            icon: 'question',
            customClass: {
                confirmButton: 'btn btn-primary  me-2',
                cancelButton: 'btn btn-secondary'
            },
            showCancelButton: true,
            confirmButtonText: 'Sí, continuar',
            cancelButtonText: 'No, cancelar',
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                // changedState
                dispatch(changedState(user, purcharseOrder?.NUMBER, status));
                // 
                if (status == 7 || status == 6) {
                    navigateTo('list');
                }
            }
        })
    }


    return (

        <>
            {showModal && (<M_Document onClose={handleCloseModal} closeOnEscape={true} closeOnBackdrop={true} />)}
            <div className='row'>
                <div className='col-12 mb-3'>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
                        <div className="d-flex mb-1">
                            <button className="btn btn-outline-dark border-0" onClick={() => navigateTo('list')}>
                                <FiArrowLeftCircle size={23} />
                            </button>
                            <h1 className="h4 fw-bold mt-2"> | Detalles de Orden [ Aprobacion ]</h1>
                        </div>
                    </div>
                </div>

                <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                    <div className="card">
                        <div className="card-header border-bottom">
                            <h5 className="card-title mb-0 fw-bold text-dark">Orden de compra: {purcharseOrder?.NUMBER}</h5>
                        </div>
                        <div className="card-body">
                            <div className="mb-2">
                                <label className="form-label">Capturo:</label>
                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.USERNAME_REGISTER} />
                            </div>
                            <div className='d-flex'>
                                <div className="mb-2 me-3">
                                    <label className="form-label">Fecha:</label>
                                    <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.DATEREGISTER} />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Hora:</label>
                                    <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.HOURREGISTER} />
                                </div>
                            </div>

                            <div className="mb-2">
                                <label className="form-label">Estado:</label>
                                <input type="text" className="form-control" disabled readOnly value={purcharseOrder?.STATUSDESC} />
                            </div>

                        </div>
                    </div>
                </div>

                <div className='col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9 col-xxl-9'>
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-start flex-wrap border-bottom">
                            <div>
                                <h4 className="mb-0 fw-bold text-dark">Orden de compra</h4>
                                <div className="d-flex flex-wrap mt-1 mb-2">
                                    <span className="badge text-bg-primary me-2">{purcharseOrder?.STATUSDESC}</span>
                                </div>
                                <div className="mt-4 mt-md-0">
                                    <button type="button" className="btn btn-outline-primary" onClick={() => setIsEditing(!isEditing)} >
                                        {isEditing ? 'Cancelar edición' : 'Editar Orden de compra'}
                                    </button>
                                </div>
                            </div>

                            <div className="mb-3 ">
                                <label className="form-label">Estado de la Orden de compra:</label>
                                <select className="form-select" value={purcharseOrder?.STATUSID || 0} onChange={(e) => chanegeStateOrder(e)}>
                                    <option value={1}>SOLICITADO</option>
                                    <option value={7}>CANCELADO</option>
                                </select>
                            </div>
                        </div>

                        <div className="card-body">
                            <div className='row'>

                                <div className='col-12'>
                                    {isEditing && (
                                        <div className="alert alert-warning">
                                            <FiAlertTriangle size={24} />  <strong> Atención: </strong> Está modificando la información de la orden de compra.
                                        </div>
                                    )}
                                </div>

                                <div className='col-12'>
                                    <Table
                                        columns={listProductsAddColumns}
                                        data={purchaseOrderDetails}
                                        function_={[]}
                                        placeholderSearch="Buscar por: Folio, Capturante, Fecha, Estado"
                                        showPagination={false}
                                        showControls={false}
                                        showTotals={false}
                                    />
                                </div>


                            </div>

                        </div>

                        <div className='card-footer text-end border-top'>
                            <button type="button" className="btn btn-outline-danger me-2" disabled={!isEditing}> <FiSlash size={22} /> Cancelar </button>
                            <button onClick={saveData} type="button" className="btn btn-outline-primary" disabled={!isEditing} > <FiSave size={22} /> Guardar </button>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
